<div class="flex  justify-between space-x-2 rounded-sm p-4 {{ bannerClass }}" [ngClass]="{ 'modal-banner': isModal }">
  <div class="flex items-center  justify-between  gap-4">
    <img *ngIf="icon" [src]="icon" alt="info" class="w-6 h-6" />
    <span class="font-bold text-base">{{ title }}</span>
  </div>
  <span class="pt-2">
     <ng-content></ng-content>
  </span>
</div>
